import { render, staticRenderFns } from "./ProspectionDetailsCard.vue?vue&type=template&id=2792ca2b&scoped=true"
import script from "./ProspectionDetailsCard.vue?vue&type=script&lang=js"
export * from "./ProspectionDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ProspectionDetailsCard.vue?vue&type=style&index=0&id=2792ca2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792ca2b",
  null
  
)

export default component.exports